import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Desktop from './components/Desktop';
import WhyUs from './components/WhyUs';
import Contacts from './components/Contacts';
import Footer from './components/Footer';

function App() {
  return (
    <>
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Desktop />
      <WhyUs />
      <Contacts />
      <Footer />
    </>
  );
}

export default App;
